import { ResetResult } from '../../Common/ResetResult/ResetResult';
import { LoginContainer } from '../ReportingLoginContainer/ReportingLoginContainer';

interface Params {
  isSuccess: boolean;
}

export const ReportingResetResult = ({ isSuccess }: Params) => {
  return (
    <LoginContainer>
      <ResetResult isSuccess={isSuccess} />
    </LoginContainer>
  );
};
